"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = functions;

var _isFunction = _interopRequireDefault(require("./isFunction.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];

  for (var key in obj) {
    if ((0, _isFunction.default)(obj[key])) names.push(key);
  }

  return names.sort();
}